import { Component, OnDestroy, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs/internal/Subject';
import { VoyadoCrmService } from 'src/app/core/services/voyado-crm.service';
import { DatePipe, DecimalPipe } from '@angular/common';
import { ContactTransaction } from '../../../core/models/contact-transaction.model';
import { finalize } from 'rxjs/internal/operators/finalize';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { ContactTransactions } from '../../../core/models/contact-transactions.model';
import { InlineSVGComponent } from '../../../../sb-modules/Frontend-Inline-SVG-Module/inline-svg.component';
import { LoaderComponent } from '../../../../sb-tools/typescript/components/loader/loader.component';
import { FocusDirective } from '../../../../sb-tools/typescript/directives/focus.directive';
import { PagingComponent } from '../../../../sb-modules/Frontend-Table-Module/components/paging/paging.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-voyado-transactions-modal',
    templateUrl: './voyado-transactions-modal.component.html',
    styleUrls: ['./voyado-transactions-modal.component.scss'],
    imports: [
        InlineSVGComponent,
        LoaderComponent,
        FocusDirective,
        PagingComponent,
        DecimalPipe,
        DatePipe,
        TranslateModule,
    ],
})
export class VoyadoTransactionsModalComponent implements OnInit, OnDestroy {
    activePage = 1;
    contactId: number;
    contactTransactions: ContactTransaction[];
    isLoading = true;
    totalItems: number;

    readonly pageSize: number = 25;
    private unsubscriber = new Subject<void>();

    constructor(
        public modalRef: BsModalRef,
        private voyadoCrmService: VoyadoCrmService,
        private decimalPipe: DecimalPipe,
    ) {}

    ngOnInit(): void {
        this.getContactTransactions(this.activePage);
    }

    decline(): void {
        this.modalRef.hide();
    }

    getContactTransactions(activePage: number): void {
        const skipItems = (activePage - 1) * this.pageSize;
        this.isLoading = true;
        this.voyadoCrmService
            .getContactTransactions(this.contactId, this.pageSize, skipItems)
            .pipe(
                takeUntil(this.unsubscriber),
                finalize(() => {
                    this.isLoading = false;
                }),
            )
            .subscribe((contactTransactions: ContactTransactions) => {
                this.contactTransactions = this.priceFormatting(contactTransactions.items);
                this.totalItems = contactTransactions.totalCount;
            });
    }

    toggleTable(element: string): void {
        document.getElementById(element).classList.toggle('closed');
    }

    private priceFormatting(contactTransactions: ContactTransaction[]): ContactTransaction[] {
        contactTransactions.forEach((contactTransaction) => {
            contactTransaction.lineItems.forEach((lineItem) => {
                lineItem.localPrice = this.decimalPipe.transform(lineItem.localPrice, '.2');
            });
        });
        return contactTransactions;
    }

    ngOnDestroy(): void {
        this.unsubscriber.next();
        this.unsubscriber.complete();
    }
}
